<template>
  <div v-if="modalReport.show" class="modal-backdrop">
    <div
      class="modal fade"
      :class="{ show: modalReport.show }"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" style="height: 200px">
          <!-- Header -->
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              {{ $t("modal.report_title") }}
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="close()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body" style="height: 80px">
            <div
              class="d-flex align-items-center justify-content-center w-100 h-100"
            >
              <input
                type="text"
                class="form-control"
                v-model="textReport"
                :placeholder="$t('modal.report_placeholder')"
              />
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer" style="height: 70px">
            <div class="d-flex align-items-center justify-content-end w-100">
              <div class="d-flex justify-content-end w-100">
                <div class="d-inline pe-2">
                  <button type="button" class="btn btn-danger" @click="close()">
                    {{ $t("modal.cancel") }}
                  </button>
                </div>
                <div class="d-inline">
                  <button type="button" class="btn btn-primary" @click="onOk()">
                    {{ $t("modal.send") }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ModalMixin } from "@/mixins/ModalMixin";
import { mapGetters } from "vuex";

export default {
  mixins: [ModalMixin],
  data() {
    return {
      textReport: "",
    };
  },
  computed: {
    ...mapGetters("modals", ["modalReport"]),
  },
  methods: {
    close() {
      this.hideReport();
      this.textReport = "";
    },
    onOk() {
      if (this.modalReport.callback) {
        this.modalReport.callback(this.textReport);
      }
      this.close();
    },
  },
};
</script>
